// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/zhengwei/xinsulv/oa-web/src/models/index';

export const models = {
model_1: { namespace: 'index', model: model_1 },
} as const
